import React, { useEffect, useState, useRef, useCallback } from 'react';
import "../estilos/Stycarrusel.css"
import { useTranslation } from 'react-i18next';
import { API_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { ruta } from '../rutas';

function EstrellasDisplay({ valor }) {
  return (
    <span className="car-estrellas">
      {[1, 2, 3, 4, 5].map(n => (
        <span key={n} className={n <= valor ? 'car-estrella-llena' : 'car-estrella-vacia'}>★</span>
      ))}
    </span>
  );
}

// Formatea slug: "tour-pacifico-norte" → "Tour Pacifico Norte"
function formatearSlug(slug) {
  if (!slug) return '';
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

function CarruselDestacados() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;

  const [destacados, setDestacados] = useState([]);
  const [indice, setIndice] = useState(0);
  const [animando, setAnimando] = useState(false);
  const intervalRef = useRef(null);
  const DURACION = 6000;

 useEffect(() => {
    fetch(`${API_URL}/destacados/`, {
      cache: "no-store"
    })
      .then((res) => res.json())
      .then((data) => setDestacados(data))
      .catch((err) => console.error(err));
  }, []);

  const irA = useCallback((siguiente) => {
    if (animando || destacados.length === 0) return;
    setAnimando(true);
    setTimeout(() => {
      setIndice(siguiente);
      setAnimando(false);
    }, 350);
  }, [animando, destacados.length]);

  const siguiente = useCallback(() => {
    irA((indice + 1) % destacados.length);
  }, [indice, destacados.length, irA]);

  const anterior = useCallback(() => {
    irA((indice - 1 + destacados.length) % destacados.length);
  }, [indice, destacados.length, irA]);

  useEffect(() => {
    if (destacados.length === 0) return;
    intervalRef.current = setInterval(siguiente, DURACION);
    return () => clearInterval(intervalRef.current);
  }, [siguiente, destacados.length]);

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(siguiente, DURACION);
  };

  if (destacados.length === 0) return null;

  const actual = destacados[indice];
  const LIMITE = 200;
  const textoCorto = actual.comentario?.length > LIMITE
    ? actual.comentario.slice(0, LIMITE) + '…'
    : actual.comentario;

  const fechaFormateada = actual.fecha
    ? new Date(actual.fecha).toLocaleDateString('es-CR', { month: 'long', year: 'numeric' })
    : '';

  return (
    <section className="carrusel-section">
      <div className="carrusel-header">
        <p className="carrusel-eyebrow">
          {lang === 'en' ? 'What travelers say' : 'Lo que dicen los viajeros'}
        </p>
        <h2 className="carrusel-titulo">
          {lang === 'en' ? 'Our Customers Reviews' : 'Reseñas de nuestros clientes'}
        </h2>
        
        
        <div className="carrusel-ver-todas">
         <button onClick={() => navigate(ruta('resenas', lang))} className="btn-ver-resenas" >  {lang === 'en' ? 'View all reviews' : 'Ver todas las reseñas'} </button>
         </div>
         </div>

      <div className="carrusel-wrapper">
        <div className={`carrusel-card ${animando ? 'fade-out' : 'fade-in'}`}>
          <span className="car-comillas">"</span>

          {/* Badge tour_slug en esquina superior derecha */}
          {actual.tour_slug && (
            <div className="car-badge-esquina">
              🌿 {formatearSlug(actual.tour_slug)}
            </div>
          )}

          <p className="car-texto">{textoCorto}</p>

          <div className="car-footer">
            <div className="car-avatar">
             <span>{(actual.nombre || '?')[0].toUpperCase()}</span></div>
            <div className="car-meta">
              <strong>{actual.nombre} {actual.apellido}</strong>
              <span>{fechaFormateada}</span>
            </div>
            <EstrellasDisplay valor={actual.puntuacion} />
          </div>
        </div>

        {/* Controles */}
        <div className="carrusel-controles">
          <button
            className="car-btn"
            onClick={() => { anterior(); resetInterval(); }}
            aria-label="Anterior"
          >
            ←
          </button>

          <div className="car-dots">
            {destacados.map((_, i) => (
              <button
                key={i}
                className={`car-dot ${i === indice ? 'activo' : ''}`}
                onClick={() => { irA(i); resetInterval(); }}
                aria-label={`Reseña ${i + 1}`}
              />
            ))}
          </div>

          <button
            className="car-btn"
            onClick={() => { siguiente(); resetInterval(); }}
            aria-label="Siguiente"
          >
            →
          </button>
        </div>

        {/* Barra de progreso */}
        <div className="car-progress-bar">
          <div
            className="car-progress-fill"
            key={indice}
            style={{ animationDuration: `${DURACION}ms` }}
          />
        </div>
      </div>
    </section>
  );
}

export default CarruselDestacados;